import { AboutTab } from '../../components/AboutTab';

export function SuperadminAbout() {
  return <AboutTab />;
}
